import { Component } from '@angular/core';
import { MCategoryResponseModal, MblogResponse } from '../blog/blog.module';
import { ActivatedRoute, Router } from '@angular/router';
import { MCommonBlogListModalRequest, MCommonListModalRequest } from 'src/app/utils/utils.service';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { async, debounceTime, lastValueFrom } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { MGetAllShopAllModuleDataResponse } from '../product/product.module';
import { ToastrService } from 'ngx-toastr';
import { LAZYLOAD_IMAGE_HOOKS } from 'ng-lazyload-image';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-blog-list-two',
  templateUrl: './blog-list-two.component.html',
  styleUrls: ['./blog-list-two.component.scss']
})
export class BlogListTwoComponent {
  categoryId: any;
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  mCommonListNewModalRequest: MCommonBlogListModalRequest = new MCommonBlogListModalRequest()
  blogs: any = []
  totalRecord: any;
  trendingBlogs: any = []
  firstBlog: any = null;
  categoryNameArray: any;
  noCategoryName: any;
  blogSearchForm!: FormGroup;
  mBlogModalRequest: MCommonListModalRequest = new MCommonListModalRequest();
  mblogResponse: any = [];
  show: boolean = false;
  historyShow: boolean = false;
  private storageKey = 'searchBlogList2History';
  searchHistory: any = null;
  arrSearchHistory: any = [];
  mGetAllShopAllModuleDataResponse: MGetAllShopAllModuleDataResponse = new MGetAllShopAllModuleDataResponse()
  subCategoryList: any = [];
  baseUrl: any = window.location.origin;
  currentUrl: any;
  share: any;
  subCategoryName: string = '';
  subCategoryId: any;
  subCategoryData: any;
  newTrend: any = null;
  allBlogs: any;
  encodeUrl: any;
  categoryColor: any;
  isLoadingBlog: boolean = false;

  constructor(private _commonBehaviorChangeService: CommonBehaviorChangeService, private router: Router, private activatedRoute: ActivatedRoute, private wsblogservice: WsBlogService, private formBuilder: FormBuilder, private wsShopAllService: WsShopallService, private toast: ToastrService, private location: Location) {
    this.blogSearchForm = this.formBuilder.group({
      search: new FormControl('')
    })
    this.activatedRoute.params.subscribe(async (data) => {
      this.getCategoryList();
      this.categoryId = data['categoryId'];
      this.subCategoryId = data['subcategoryId'];
      if (this.subCategoryId) {
        this.getNewBlogList(this.subCategoryId);
      }
      else {
        if (this.categoryId == 'editors-pick') {
          this.getEditorsPickBlogList(null, true);
        }
        else {
          if (this.categoryId) {
            this.getNewBlogList();
          }
          else {
            this.getEditorsPickBlogList(true, null);
            this.newTrend = true;
          }
        }
      }
    })

    this.getTrendingBlogList()

    this.blogSearchForm.get('search')?.valueChanges.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.getBlogSearchList();
    });

    document.body.addEventListener('click', this.toggleShareBox.bind(this));
  }


  /**
  * Hide Share Box on outside click
  * @param event 
  */
  toggleShareBox(event: Event): void {
    const isInsideBlogIcon = (event.target as HTMLElement).closest('.blog-icon');
    const isSearchBlog = (event.target as HTMLElement).closest('.new-blog-search');
    if (!isInsideBlogIcon) {
      this.share = null; // Hides the share box when clicked outside
    }
    if (!isSearchBlog) {
      this.show = false;
      this.historyShow = false;
    }
  }

  rediretToBlogList(category: any) {
    this.router.navigate(['/blog-list/' + category])
  }

  backClick() {
    this.location.back();
  }

  ngOnDestroy() {
    document.body.removeEventListener('click', this.toggleShareBox.bind(this));
  }

  async getBlogSearchList() {
    this.mBlogModalRequest.skip = 0;
    this.mBlogModalRequest.take = 1000;
    this.mBlogModalRequest.search = this.blogSearchForm.controls['search'].value;
    if (this.blogSearchForm.controls['search'].value.length > 0) {
      this.show = true;
      this.historyShow = false;
      const getBlogs = this.wsblogservice.getBlogList(this.mBlogModalRequest);
      await lastValueFrom(getBlogs).then(response => {
        if (response && response.statusCode == 200) {
          this.mblogResponse.data = response.data;
          this.mblogResponse.data = this.mblogResponse.data.filter((item: any) => {
            if (item?.is_active == false) {
              return false;
            }
            return true;
          })
        }
      })
    }
    else {
      this.show = false;
      this.mblogResponse.data = [];
    }
  }

  openAllBlogs() {
    this.router.navigate(['/blog']);
  }

  openBlogByCategory() {
    this.router.onSameUrlNavigation = 'reload';
    if (this.categoryId == 'editors-pick') {
      this.getEditorsPickBlogList(null, true);
    }
    else {
      this.getNewBlogList();
    }
  }

  openSkinConcern() {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], {
      queryParams: {
        sc: ''
      }
    })
  }

  clickSearch() {
    if (this.blogSearchForm.controls['search'].value == '' || this.blogSearchForm.controls['search'].value == null) {
      this.show = false;
      this.getSearchHistory();
      if (this.arrSearchHistory && this.arrSearchHistory.length > 0) {
        this.historyShow = !this.historyShow;
      }
    }
    else {
      this.historyShow = false;
      this.show = !this.show;
    }
  }

  async getAllModuleDataOfShopAll(catId: any) {
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll("" + catId)
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetAllShopAllModuleDataResponse.data = response.data;
        this.subCategoryList = this.mGetAllShopAllModuleDataResponse.data['subCategoryList'];
        this.subCategoryList = this.subCategoryList.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
      }
    })
  }


  showShare(hide?: any) {
    if (hide == 'hide') {
      this.share = null;
    }
    else {
      if (this.share == hide.id) {
        this.share = null;
      }
      else {
        this.share = hide.id;
        this.currentUrl = decodeURI(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id);
        this.encodeUrl = encodeURIComponent(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id);
      }
    }
  }


  clickToCopy(copy: any) {

    const blogData = this.baseUrl + "/individual-blog-updated/" + copy.title.split(' ').join('_') + '/' + copy.category_id + '/' + copy.id;

    // Create a dummy textarea element to perform the copying
    const textarea = document.createElement('textarea');
    textarea.value = blogData;
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();
    document.execCommand('copy');

    // Clean up - remove the textarea
    document.body.removeChild(textarea);
    this._commonBehaviorChangeService.getToast('Blog Link Copied');

    this.showShare('hide');
  }

  getSearchHistory() {
    this.searchHistory = localStorage.getItem(this.storageKey);
    if (this.searchHistory != 'undefined' && this.searchHistory != null) {
      this.arrSearchHistory = JSON.parse(this.searchHistory)
    }
    return this.arrSearchHistory;
  }

  async getEditorsPickBlogList(trending: any, editor: any) {
    this.blogs = [];
    const editorsPickBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(trending, editor);
    await lastValueFrom(editorsPickBlogs).then(async response => {
      if (response && response.statusCode == 200 && response.data) {
        await response.data.forEach((blog: any) => {
          if (this.blogs.length < 1) {
            this.blogs = blog.blogs;
          } else {
            this.blogs = [...this.blogs, ...blog.blogs];
          }
        });
        this.blogs = this.blogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
      }
    })
  }

  /**
 * to get category list
 */
  async getCategoryList(category_id?: any) {
    const categoryListData = this.wsblogservice.getCategoryByType(2);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
        this.categoryNameArray = this.mCategoryResponseModal.data.filter((item: any) => item.id === parseInt(this.categoryId));
      }
    })
  }

  /**
 * to get Blog List  
 */
  async getNewBlogList(subcategoryId?: any, subCategoryName?: any, category?: any) {
    this.mCommonListNewModalRequest.take = 6;
    this.mCommonListNewModalRequest.catagoryid = parseInt(this.categoryId);
    this.isLoadingBlog = true;
    if (subcategoryId && subcategoryId !== null) {
      this.mCommonListNewModalRequest.subcategoryid = parseInt(subcategoryId);
    }

    const skinCareBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListNewModalRequest);
    await lastValueFrom(skinCareBlogs).then(response => {
      if (response && response.statusCode == 200) {
        if (this.mCommonListModalRequest.skip == 0) {
          if (subcategoryId && subcategoryId != null) {
            this.subCategoryId = subcategoryId;
          }
          if (subCategoryName && subCategoryName !== null) {
            this.subCategoryName = subCategoryName;
          }
          else {
            if (subcategoryId && subcategoryId != null) {
              this.getSubCategoryList(this.categoryId, subcategoryId);
            }
            else {
              this.subCategoryName = '';
            }
          }
          this.blogs = response.data;
          this.getAllModuleDataOfShopAll(this.blogs[0]?.category_id);
        } else {
          this.blogs = [...this.blogs, ...response.data];
        }
        this.blogs = this.blogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if(this.blogs && this.blogs.length > 0){
          this.categoryColor = this.blogs[0].category.color;
        }
        this.isLoadingBlog = false;
        this.totalRecord = response.totalRecords;
      }
    })
  }

  async getSubCategoryList(categoryId: any, subCategoryId: any) {
    this.mBlogModalRequest.skip = 0;
    this.mBlogModalRequest.take = 1000;
    this.mBlogModalRequest.search = '';
    this.mBlogModalRequest.categoryIds = "" + categoryId;
    const getSubCategoryList = this.wsShopAllService.getAllSubCategory(this.mBlogModalRequest);
    await lastValueFrom(getSubCategoryList).then(response => {
      if (response && response.statusCode == 200) {
        let subCategoryData = response.data;
        if (subCategoryData && subCategoryData.length > 0 && subCategoryId != null) {
          this.subCategoryData = subCategoryData.filter((item: any) => item.id == subCategoryId)
          this.subCategoryName = this.subCategoryData[0].name;
        }
      }
    })
  }

  async openBlogList(categoryId: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/blog-list/" + categoryId])
  }

  showMoreResults() {
    if (this.blogs.length > 0 && this.blogs.length + 1 < this.totalRecord) {
      this.mCommonListModalRequest.skip = this.blogs.length + 1;
      this.getNewBlogList();
    }
  }

  openSearchBlogDetail(val: any) {
    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item.id == val.id)
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item.id != val.id);
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.navigate(["/individual-blog-updated/" + val.title.split(' ').join('_') + '/' + val.category_id + '/' + val.id])
  }


  async openBlogDetail(val: any) {
    this.router.navigate(["/individual-blog-updated/" + val.title.split(' ').join('_') + '/' + val.category_id + '/' + val.id])
  }

  /**
   * to get trending blog list
   */
  async getTrendingBlogList() {
    this.trendingBlogs = [];
    const trendingBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(true);
    await lastValueFrom(trendingBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        response.data.forEach((blog: any) => {
          if (this.trendingBlogs.length < 1) {
            this.trendingBlogs = blog.blogs;
          } else {
            this.trendingBlogs = [...this.trendingBlogs, ...blog.blogs];
          }
        })
      } else {
      }
    })
  }

  async commingSoon() {
    this._commonBehaviorChangeService.getToast('Skin Test will be live soon!');
  }

}

